'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var _smooth_scroll_1 = require("./class/_smooth_scroll");
var _hamburger_1 = require("./class/_hamburger");
var _slick_1 = require("./class/_slick");
var _scroll_active_1 = require("./class/_scroll_active");
var _modal_1 = require("./class/_modal");
var _orientation_1 = require("./class/_orientation");
var _neon_box_1 = require("./class/_neon_box");
var _obog_1 = require("./class/_obog");
var _club_1 = require("./class/_club");
var _go_1 = require("./class/_go");
var _anchor_disabled_1 = require("./class/_anchor_disabled");
new _smooth_scroll_1.default;
$(function () {
    new _hamburger_1.default;
    new _slick_1.default();
    new _scroll_active_1.default();
    new _modal_1.default();
    new _orientation_1.default();
    new _neon_box_1.default;
    new _obog_1.default;
    new _club_1.default;
    new _go_1.default;
    new _anchor_disabled_1.default;
});
